import { render, staticRenderFns } from "./CreatedTrainingDetailPage.vue?vue&type=template&id=d522befe&scoped=true&"
import script from "./CreatedTrainingDetailPage.vue?vue&type=script&lang=js&"
export * from "./CreatedTrainingDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatedTrainingDetailPage.vue?vue&type=style&index=0&id=d522befe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d522befe",
  null
  
)

export default component.exports